import { MessageCircle, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSiteContent } from "@/lib/siteContent";

export default function PublicContato() {
  const { content } = useSiteContent();
  const c = content.contato || {};
  const items = [
    { icon: MessageCircle, label: "WhatsApp", value: c.whatsapp_label || "Comercial ATP", href: c.whatsapp_url || "https://wa.me/", tid: "contact-wa" },
    { icon: Mail, label: "E-mail", value: c.email || "financeiro@atpconfec.com", href: `mailto:${c.email || "financeiro@atpconfec.com"}`, tid: "contact-email" },
    { icon: MapPin, label: "Atendimento", value: c.location || "Todo Brasil (remoto)", href: "#", tid: "contact-loc" },
  ];
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
      <div className="text-xs font-mono uppercase tracking-widest text-[#0CDBF2] mb-3">{c.kicker || "Contato"}</div>
      <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight mb-4">{c.title}</h1>
      <p className="text-slate-400 max-w-2xl mb-10">{c.description}</p>
      <div className="grid md:grid-cols-3 gap-4">
        {items.map((it) => (
          <a key={it.label} href={it.href} target="_blank" rel="noreferrer" data-testid={it.tid}
            className="rounded-xl border border-slate-800 bg-[#0B0F17] p-6 hover:border-[#0CDBF2]/50 transition-colors">
            <it.icon className="text-[#0CDBF2] mb-3" />
            <div className="text-xs text-slate-500 uppercase tracking-widest">{it.label}</div>
            <div className="font-medium mt-1">{it.value}</div>
          </a>
        ))}
      </div>
      <div className="mt-10">
        <Link to="/orcamento" data-testid="contact-cta-quote">
          <Button size="lg" className="bg-[#0CDBF2] hover:bg-[#0ABED4] text-[#07090E] font-semibold">Solicitar orçamento</Button>
        </Link>
      </div>
    </div>
  );
}
